import { render } from "./LabdaqCompletedOrders.vue?vue&type=template&id=9a79eada"
import script from "./LabdaqCompletedOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqCompletedOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/LabdaqCompletedOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a79eada"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a79eada', __exports__)) {
    console.log('reload')
    api.reload('9a79eada', __exports__)
  }
  
  module.hot.accept("./LabdaqCompletedOrders.vue?vue&type=template&id=9a79eada", () => {
    console.log('re-render')
    api.rerender('9a79eada', render)
  })

}


export default __exports__